import { render, staticRenderFns } from "./TheTour.vue?vue&type=template&id=73b8143a"
import script from "./TheTour.vue?vue&type=script&lang=ts"
export * from "./TheTour.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsMyLightBox: require('/usr/src/nuxt-app/components/elements/MyLightBox.vue').default})
